<template>
  <div>
    <Header />
    <div>
      <span class="navTitle">
        {{ this.exhibitName }} > Ajouter une ressource</span
      >
      <br />
      <q-btn color="pink-10" style="margin-left: 7%" @click="navigateToExpo"
        >Retour</q-btn
      >

      <hr style="margin-bottom: 15px; margin-top: 15px" />

      <q-form class="form">
        <q-input
          v-model="name"
          outlined
          label="Nom du fichier"
          disable
        ></q-input>
        <q-input outlined v-model="title" label="Nom" required></q-input>
        <q-input
          outlined
          type="textarea"
          label="Description"
          v-model="description"
        ></q-input>
        <input
          outlined
          type="file"
          label="Fichier"
          id="file"
          ref="file"
          @change="selectFile"
        />
      </q-form>
      <q-btn
        style="margin-left: 20%; margin-top: 20px"
        color="secondary"
        class="send"
        @click="send()"
        >Envoyer</q-btn
      >
      <q-inner-loading :showing="visible">
        <q-spinner-gears size="50px" color="primary" />
      </q-inner-loading>
      <q-banner v-if="success" class="banner bg-secondary text-white banner">
        Données enregistrées
      </q-banner>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Header from "../components/Header.vue";
export default {
  components: {
    Header,
  },
  data() {
    return {
      file: null,
      name: "",
      success: false,
      description: "",
      title: "",
      visible: false
    };
  },
  computed: {
    id() {
      return this.$store.state.exhibitId;
    },
    index() {
      return this.$store.state.resourcesCount;
    },
    exhibitName() {
      return this.$store.state.exhibitName;
    },
  },
  methods: {
    navigateToExpo() {
      this.$router.push({ path: "/expo/" + this.id });
    },
    selectFile(event) {
      this.file = event.target.files[0];
      console.log(event);
      if (event.target.files.length != 0)
        this.name = event.target.files[0].name;
    },
    navigateToAdmin() {
      this.$router.push({ path: "/admin/" + this.$store.state.userId });
    },
    async send() {
      try {
        this.visible=true;

        let formData = new FormData();
        formData.append("file", this.file);
        formData.append("name", this.name);
        formData.append("description", this.description);
        formData.append("title", this.title);
        formData.append("exhibitId", this.id);
        formData.append("index", this.index);

        let url = `${process.env.VUE_APP_BASEURL}/file`;
        let response = await axios.post(url, formData);
        if (response.status == 200) {
          this.visible = false;
          this.success = true;
          setTimeout(() => {
            this.success = false;
          }, 1500);
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
  mounted() {
  },
};
</script>

<style scoped>
.form {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 60%;
  height: 60vh;
  margin: auto;
}
.banner {
  position: absolute;
  top: 50%;
  left: 30%;
  width: 40%;
}
</style>